import { Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { CONTENT_TYPE, MEDIA_SIZE } from "@/constants/index.js";

import { getMediaLink } from "../../../utils/mediaLink";

const useStyles = makeStyles({
  parentThumbnail: {
    cursor: ({ cursorMode }) => (cursorMode ? "pointer" : "inherit"),
  },
  imageThumbnails: {
    width: "100%",
    height: "100%",
    visibility: "hidden",
  },
  imageThumbnailsContainer: {
    backdropFilter: "blur(5px)",
    boxShadow: "0px 20px 40px rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    "&:hover": {
      "&::before": {
        content: "''",
        position: "absolute",
        left: "0px",
        right: "0px",
        top: "0px",
        bottom: "0px",
        background: "rgba(0,0,0,0.5)",
      },
      "& .imagesHover": { height: "100%" },
    },
    "&:after": {
      content: '""',
      display: "block",
      paddingBottom: "100%",
    },
    "& .imagesHover": {
      fontSize: "1rem",
      color: "#FFF",
      lineHeight: "22px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      top: "0px",
      left: "0px",
      bottom: "0px",
      right: "0px",
      height: "0px",
      transition: ".5s ease",
      overflow: "hidden",
    },
    "&.empty": {
      backgroundColor: "rgba(0,0,0,0.65)",
    },
  },
  name: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "2 /* number of lines to show */",
    WebkitBoxOrient: "vertical",
    textAlign: "center",
    padding: "0 2px",
  },
  type: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "1 /* number of lines to show */",
    WebkitBoxOrient: "vertical",
    textAlign: "center",
  },
  imageSelected: {
    fontSize: "1rem",
    color: "#FFF",
    lineHeight: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0px",
    left: "0px",
    bottom: "0px",
    right: "0px",
    height: "100%",
    transition: ".5s ease",
    overflow: "hidden",
    flexDirection: "column",
  },
  thumbnailContainer: {
    width: "8rem",
    height: "8rem",
    overflow: "hidden",
    borderRadius: "2px",
  },
  thumbnailContainerActive: {
    boxShadow: "0 0 0 2px #fff",
    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.1))",
  },
  thumbnail: {
    objectFit: "cover",
    height: "100%",
    width: "100%",
  },
  thumbnailLazy: {
    objectFit: "cover",
    visibility: "hidden",
    height: "100%",
    width: "100%",
    "&.swiper-lazy-loaded": {
      visibility: "visible",
    },
  },
});

const useStylesTooltip = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "#333",
    color: "white",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
  },
}));

export default function FullscreenThumbnail(props) {
  const {
    isActive,
    mediaItem: { contentType, name, thumbnailUrl },
  } = props;

  const classes = useStyles();
  const classesTooltip = useStylesTooltip();

  const src = getMediaLink({ link: thumbnailUrl, size: MEDIA_SIZE.small });

  return (
    <div className={classes.parentThumbnail}>
      {src && contentType.value !== CONTENT_TYPE.LINK ? (
        <Tooltip
          classes={classesTooltip}
          data-testid="html-tooltip"
          title={
            <Typography color="inherit">
              {name}-{contentType.value}
            </Typography>
          }
        >
          <div className={`${classes.thumbnailContainer} ${isActive ? classes.thumbnailContainerActive : ""}`}>
            <img src={src} alt={name} className={classes.thumbnail} />
          </div>
        </Tooltip>
      ) : (
        <div
          className={`${classes.imageThumbnailsContainer} ${isActive ? classes.thumbnailContainerActive : ""} empty`}
          role="button"
          data-testid={`thumbnails-container${isActive ? "-active" : ""}`}
        >
          <div className={classes.imageSelected}>
            <span className={classes.name} style={{ fontStyle: name ? "inherit" : "italic" }}>
              {name || "Untitled"}
            </span>
            <span className={classes.type}>{contentType.value}</span>
          </div>
        </div>
      )}
    </div>
  );
}
